$(document).on('ajax:complete', 'a[data-refresh=true]', () => {
  window.location.href = window.location.href;
});
